import { useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useMediaGalleryContext } from '@/components/Recipe/FlowComponents/MediaGalleryContext';
import { useVideoView } from '@/components/Recipe/FlowContext';
import { useHotkeyScope } from '@/hooks/useHotkeyScope';
import { useIsHovered } from '@/hooks/useIsHovered';
import { TrackTypeEnum } from '@/hooks/useAnalytics';
import { track } from '@/utils/analytics';

export const useShowGallery = (id: string, selectedIndexOnNode: number = 0) => {
  const { openGallery } = useMediaGalleryContext();
  const videoView = useVideoView(id, selectedIndexOnNode);
  const { isHovered, ...hoverElementProps } = useIsHovered();

  const handleOpenGallery = useCallback(() => {
    videoView.pauseIfPlaying();
    openGallery({ nodeId: id });
  }, [id, openGallery, videoView]);

  const handleSpaceKey = useCallback(
    (event: KeyboardEvent) => {
      if (isHovered) {
        event.preventDefault();
        event.stopPropagation();
        track(
          'media_gallery_open_triggered_by_space_key',
          {
            node_id: id,
          },
          TrackTypeEnum.Product,
        );
        handleOpenGallery();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isHovered, handleOpenGallery],
  );

  useHotkeyScope('model-gallery');
  useHotkeys('space', handleSpaceKey, { scopes: 'model-gallery' });

  return {
    handleOpenGallery,
    isHovered,
    ...hoverElementProps,
  };
};
